var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattleTips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9995,
    cy: 14.9995,
    r: 14.9995,
    fill: "#3A0049"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0001 29.9987C23.2841 29.9987 29.9996 23.2832 29.9996 14.9992C29.9996 12.4185 29.3479 9.98996 28.2 7.8693C25.5625 5.56328 22.1102 4.16602 18.3315 4.16602C10.0475 4.16602 3.33203 10.8815 3.33203 19.1655C3.33203 21.7462 3.98379 24.1747 5.13168 26.2954C7.76917 28.6014 11.2215 29.9987 15.0001 29.9987Z",
    fill: "#420A51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 14.9997H6.66663M14.9997 5.625V6.66663M23.3327 14.9997H24.3743M8.33324 8.33324L9.06238 9.06238M21.6661 8.33324L20.937 9.06238M11.8748 19.1662C11.0003 18.5103 10.3543 17.596 10.0284 16.5526C9.70249 15.5092 9.71312 14.3897 10.0588 13.3527C10.4045 12.3157 11.0676 11.4137 11.9544 10.7746C12.8412 10.1355 13.9066 9.79152 14.9997 9.79152C16.0928 9.79152 17.1582 10.1355 18.0449 10.7746C18.9317 11.4137 19.5949 12.3157 19.9406 13.3527C20.2862 14.3897 20.2969 15.5092 19.9709 16.5526C19.645 17.596 18.999 18.5103 18.1246 19.1662C17.7179 19.5688 17.4117 20.0614 17.2307 20.6043C17.0498 21.1472 16.9991 21.725 17.0829 22.2911C17.0829 22.8436 16.8634 23.3735 16.4728 23.7642C16.0821 24.1549 15.5522 24.3743 14.9997 24.3743C14.4472 24.3743 13.9173 24.1549 13.5266 23.7642C13.1359 23.3735 12.9164 22.8436 12.9164 22.2911C13.0002 21.725 12.9496 21.1472 12.7686 20.6043C12.5877 20.0614 12.2815 19.5688 11.8748 19.1662M12.6039 20.2078H17.3954",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattleTips);
export default __webpack_public_path__ + "static/media/battleTips.7a1c7325c9751502b2740becb045d963.svg";
export { ForwardRef as ReactComponent };